module.exports = __webpack_public_path__ + "assets/certification-desktop.caeb0817fce0f04335adb7db6de8ac7d.png";